import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import { CONSUMER_COMPLAINT_CONVERSATION } from "tagTypes";

export const useComplaintConversationQuery = (id, query = {}) =>
  useGetQuery({
    endpoint: `/consumer-complaint/${id}/consumer-complaint-conversation`,
    query,
    tags: [CONSUMER_COMPLAINT_CONVERSATION],
  });

export const useLazyComplaintConversationQuery = () => {
  const [consumerComplaintConversation, data] = useLazyGetQuery();
  const complaintConversation = async (id, query = {}) =>
    await consumerComplaintConversation(
      {
        endpoint: `/consumer-complaint/${id}/consumer-complaint-conversation`,
        query,
        tags: [CONSUMER_COMPLAINT_CONVERSATION],
      },
      true
    ).unwrap();
  return [complaintConversation, data];
};

export const usePostComplaintConversationMutation = () => {
  const [consumerComplaintConversation, data] = usePostMutation();
  const complaintConversation = async (payload, query = {}) =>
    await consumerComplaintConversation({
      endpoint: "/consumer-complaint-conversation",
      query,
      payload: payload || {},
      tags: [CONSUMER_COMPLAINT_CONVERSATION],
    }).unwrap();
  return [complaintConversation, data];
};
